import React, { useEffect, useState } from "react";
import {
  Button,
  TextBox,
  Modal,
  Checkbox,
  ButtonGroup,
  DatePicker,
  DateRange,
  Select,
  SelectOption,
  IconPlus,
  Card,
  IconX,
  IconSave,
  RadioButton,
  ListItem,
} from "@veneer/core";
import { useTranslation } from "react-i18next";
import "../../assets/css/components/surveys/surveyEditorModal.css";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import dataListService from "../../services/generalApi/dataList.service";
import appointmentService from "../../services/agendaApi/appointment.service";
import LoaderModal from "../Loader/loaderModal";
import surveyService from "../../services/surveyApi/survey.service";
import { IFieldDto } from "../../models/dto/surveyApi/IFieldDto";
import { ICountryDto } from "../../models/dto/generalApi/ICountryDto";
import { ICityDto } from "../../models/dto/surveyApi/ICityDto";
import { IPosDto } from "../../models/dto/agendaApi/IPosDto";
import {
  ISurveyIn,
  ISurveyUpdateIn,
} from "../../models/input/surveyApi/ISurveyIn";
import {
  ISurveyDetailDto,
  ISurveyDto,
} from "../../models/dto/surveyApi/ISurveyDto";
import SimpleMessageModalWithOpenClose from "../../components/Modals/SimpleMessageModalWithOpenClose";

interface SurveyEditorProps {
  onClose: () => void;
  isUpdating: boolean;
  surveyToEdit?: ISurveyDto;
}
type SelectValue = number | string | boolean; //CHECK

interface Questions {
  QuestionID?: number;
  Input: string;
  Type: number;
  Mandatory: boolean;
  PhotoMandatory: boolean;
  Order: number;
  QuestionOptional: boolean;
  OptionConditional: number;
  Condition: string;
  NumberOptions: SelectValue[];
  Options: string[];
}

interface IGroupedQuestion {
  questionID: number;
  question: string;
  options: string[];
  type: number;
}

const SurveyEditorModal: React.FC<SurveyEditorProps> = ({
  onClose,
  isUpdating,
  surveyToEdit,
}) => {
  const [t] = useTranslation("global");
  const languageId: any = useSelector((state: RootState) => state.languageId);

  const [surveyId, setSurveyId] = useState<number>(NaN);
  const [nameSurvey, setSurveyName] = useState<string>("");
  const [checkboxIndefinite, setCheckboxIndefinite] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");

  const [numberTab, setNumberTab] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(true);

  const [errorDatePicker, setErrorDatePicker] = useState<boolean>(false);

  const [tab0Disable, setTab0Disable] = useState<boolean>(true);
  const [tab1Disable, setTab1Disable] = useState<boolean>(true);
  const [tab2Disable, setTab2Disable] = useState<boolean>(true);

  const [disabledRoles, setDisabledRoles] = useState<boolean>(true);
  const [disabledCountries, setDisabledCountries] = useState<boolean>(true);
  const [disabledSubretails, setDisabledSubretails] = useState<boolean>(true);
  const [disabledCities, setDisabledCities] = useState<boolean>(true);
  const [disabledPos, setDisabledPos] = useState<boolean>(true);

  const [showModalConditional, setShowModalConditional] =
    useState<boolean>(false);
  const [disabledAddConditional, setDisabledAddConditional] =
    useState<boolean>(true);
  const [disabledOptionQuestion, setDisabledOptionQuestion] =
    useState<boolean>(true);

  const [roles, setRoles] = useState<SelectOption[]>([]);
  const [rolesSelected, setRolesSelected] = useState<SelectValue[]>([]);
  const [countries, setCountries] = useState<SelectOption[]>([]);
  const [countriesSelected, setCountriesSelected] = useState<SelectValue[]>([]);
  const [cities, setCities] = useState<SelectOption[]>([]);
  const [citiesFiltered, setCitiesFiltered] = useState<SelectOption[]>([]);
  const [citiesSelected, setCitiesSelected] = useState<SelectValue[]>([]);
  const [subretails, setSubretails] = useState<SelectOption[]>([]);
  const [subretailsSelected, setSubretailsSelected] = useState<SelectValue[]>(
    []
  );
  const [pos, setPos] = useState<SelectOption[]>([]);
  const [posFiltered, setPosFiltered] = useState<SelectOption[]>([]);
  const [posSelected, setPosSelected] = useState<SelectValue[]>([]);

  const [questionType, setQuestionType] = useState<SelectValue[]>([]);
  const [indexQuestion, setIndexQuestion] = useState<SelectValue[]>([]);
  const [optionQuestion, setOptionQuestion] = useState<SelectValue[]>([]);
  const [surveyDetailsActual, setSurveyDetailsActual] = useState<
    ISurveyDetailDto[]
  >([]);

  const [questions, setQuestions] = useState<Questions[]>([]);
  const [surveyDetailSelected, setSurveyDetailSelected] = useState<
    IGroupedQuestion[]
  >([]);
  const [optionsConditional, setOptionsConditional] = useState<string[]>([]);

  interface IModalMessage {
    show: boolean,
    message: string,
    title: string,
    onClose: React.Dispatch<React.SetStateAction<boolean>>
  };
  
  const [modalMessage, setModalMessage] = useState<IModalMessage>({
    show: false,
    message: '',
    title: '',
    onClose: function() {}
  });

  useEffect(() => {
    setLoading(true);
    if (isUpdating) {
      if (surveyToEdit) {
        chargeDataToUpdate(surveyToEdit);
      } else {
        onClose();
      }
    } else {
      getFiltersData();
    }
  }, []);

  useEffect(() => {
    if (checkboxIndefinite) {
      if (nameSurvey.length >= 3) {
        setTab0Disable(false);
      } else {
        setTab0Disable(true);
      }
    } else {
      if (
        nameSurvey.length >= 3 &&
        startDate.length > 0 &&
        endDate.length > 0
      ) {
        setTab0Disable(false);
      } else {
        setTab0Disable(true);
      }
    }
  }, [nameSurvey, checkboxIndefinite, startDate, endDate]);

  useEffect(() => {
    setCities([]);
    setCitiesFiltered([]);
    setCitiesSelected([]);
    setDisabledCities(true);
    if (countriesSelected.length > 0) {
      if (!isUpdating) {
        getCitiesData();
      } else {
        getCitiesData().then((citiesResponse) => {
          if (surveyDetailsActual[0].cities.length > 0 && citiesResponse) {
            let citiesArray = surveyDetailsActual[0].cities
              .split(",")
              .map((city) => parseInt(city.trim(), 10));
            let citiesTemp = citiesArray.filter((city: string | number) =>
              citiesResponse.some((r: SelectOption) => r.value === Number(city))
            );
            setCitiesSelected([...citiesTemp]);
          }
        });
      }
    }
  }, [countriesSelected]);

  useEffect(() => {
    setPosSelected([]);
    setPos([]);
    setPosFiltered([]);
    setDisabledPos(true);
    if (subretailsSelected.length > 0) {
      if (!isUpdating) {
        getPosData();
      } else {
        getPosData().then((posResponse) => {
          if (surveyDetailsActual[0].posCodes.length > 0 && posResponse) {
            let posArray = surveyDetailsActual[0].posCodes
              .split(",")
              .map((pos) => pos.trim());
            let posTemp = posArray.filter((item: string | number) =>
              posResponse.some((r: SelectOption) => r.value === String(item))
            );
            setPosSelected([...posTemp]);
          }
        });
      }
    }
  }, [subretailsSelected]);

  useEffect(() => {
    if (
      questionType.length > 0 &&
      indexQuestion.length > 0 &&
      optionQuestion.length > 0
    ) {
      setDisabledAddConditional(false);
    } else {
      setDisabledAddConditional(true);
    }
  }, [questionType, indexQuestion, optionQuestion]);

  useEffect(() => {
    const hasEmptyInput = questions.some((item) => item.Input === "");

    const hasEmptyOptions = questions.some((item) => {
      if (Array.isArray(item.Options)) {
        return item.Options.some((option) => option === "");
      }
      return false;
    });

    const hasEmptyNumberOptions = questions.some((item) => {
      if (Array.isArray(item.Options)) {
        return (
          (item.Type === 2 || item.Type === 3) &&
          item.NumberOptions.length === 0
        );
      }
      return false;
    });

    if (hasEmptyInput || hasEmptyOptions || hasEmptyNumberOptions) {
      setTab2Disable(true);
    } else {
      setTab2Disable(false);
    }
  }, [questions]);

  useEffect(() => {
    if (indexQuestion.length > 0) {
      const optionsTemp = questions[Number(indexQuestion)].Options;
      setOptionsConditional(optionsTemp);
      setDisabledOptionQuestion(false);
    } else {
      setOptionsConditional([]);
      setDisabledOptionQuestion(true);
    }
  }, [indexQuestion]);

  const getFiltersData = async () => {
    try {
      setLoading(true);
      const roleList = await surveyService.getRoleList(languageId.value, 2);
      if (!Array.isArray(roleList) || roleList.length === 0) {
        setRoles([]);
        setDisabledRoles(true);
      } else {
        const resultRole = fillData(roleList);
        setRoles(resultRole);
        setDisabledRoles(false);
      }

      const countryList = await dataListService.getCountryListBySubregion();
      const resultCountries = fillDataCountries(countryList);
      setCountries(resultCountries);

      const subretailList = await appointmentService.getSubretailList();
      const resultSubretails = fillData(subretailList);
      setSubretails(resultSubretails);
    } catch (error) {
      console.error(error);
      setLoading(false);
      onClose();
    } finally {
      setLoading(false);
      setDisabledCountries(false);
      setDisabledSubretails(false);
    }
  };

  const getCitiesData = async () => {
    try {
      const cities = await surveyService.getCitiesByCountry(
        String(countriesSelected)
      );
      const resultCities = fillDataCities(cities);
      setCities(resultCities);
      setCitiesFiltered(resultCities);
      return resultCities;
    } catch (error) {
      console.error(error);
      setDisabledCities(true);
    } finally {
      setDisabledCities(false);
    }
  };

  const getPosData = async () => {
    try {
      const pos = await appointmentService.getPosListBySubretailList(
        String(subretailsSelected)
      );
      if (!Array.isArray(pos) || pos.length === 0) {
        setDisabledPos(true);
        setPos([]);
        setPosFiltered([]);
        return;
      }

      const resultPos = fillDataPos(pos);
      setPos(resultPos);
      setPosFiltered(resultPos);
      setDisabledPos(false);
      return resultPos;
    } catch (error) {
      console.error(error);
      setDisabledPos(true);
    }
  };

  const fillData = (data: IFieldDto[]) => {
    const dataTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const camp: IFieldDto = data[i];
      let selectData: SelectOption;
      selectData = {
        value: camp.fieldID,
        label: camp.fieldValue,
      };
      dataTemp.push(selectData);
    }
    return dataTemp;
  };

  const fillDataCountries = (data: ICountryDto[]) => {
    const dataTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const camp: ICountryDto = data[i];
      let selectData: SelectOption;
      selectData = {
        value: camp.contryId,
        label: camp.countryName,
      };
      dataTemp.push(selectData);
    }
    return dataTemp;
  };

  const fillDataCities = (data: ICityDto[]) => {
    const dataTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const camp: ICityDto = data[i];
      let selectData: SelectOption;
      selectData = {
        value: camp.cityID,
        label: camp.cityName,
      };
      dataTemp.push(selectData);
    }
    return dataTemp;
  };

  const fillDataPos = (data: IPosDto[]) => {
    const dataTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const camp: IPosDto = data[i];
      let selectData: SelectOption;
      selectData = {
        value: camp.fieldID,
        label: camp.fieldValue,
      };
      dataTemp.push(selectData);
    }
    return dataTemp;
  };

  const FormatDate = (date: string) => {
    let timestamp = Date.parse(date);
    if (!isNaN(timestamp)) {
      let dateTemp = new Date(date);
      let year = dateTemp.getFullYear();
      let month = (dateTemp.getMonth() + 1).toString().padStart(2, "0");
      let day = dateTemp.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    } else {
      return "";
    }
  };

  const chargeDataToUpdate = async (surveyData: ISurveyDto) => {
    let roleList: any;
    let countryList: any;
    let subretailList: any;

    try {
      await chargeSurveyData(surveyData);
      const surveyDetails = await getSurveyDetails(surveyData.surveyID);
      fillDataSurveyQuestions(surveyDetails);
      setSurveyDetailsActual(surveyDetails);

      const [roleData, countryData, subretailData] = await Promise.all([
        surveyService.getRoleList(languageId.value, 2),
        dataListService.getCountryListBySubregion(),
        appointmentService.getSubretailList(),
      ]);

      if (!Array.isArray(roleData) || roleData.length === 0) {
        setRoles([]);
        setDisabledRoles(true);
      } else {
        roleList = fillData(roleData);
        setRoles(roleList);
        setDisabledRoles(false);
      }

      countryList = fillDataCountries(countryData);
      subretailList = fillData(subretailData);

      setCountries(countryList);
      setSubretails(subretailList);

      setDisabledCountries(false);
      setDisabledSubretails(false);

      fillDataSurveyFilters(
        surveyDetails,
        roleList,
        countryList,
        subretailList
      );
    } catch (error) {
      console.error(error);
      setLoading(false);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  const chargeSurveyData = (surveyData: ISurveyDto) => {
    return new Promise<void>((resolve, reject) => {
      try {
        setSurveyId(surveyData.surveyID);
        setSurveyName(surveyData.surveyName);
        if (surveyData.isUndefined) {
          setCheckboxIndefinite(true);
        } else {
          setCheckboxIndefinite(false);
          setStartDate(surveyData.startDate);
          setEndDate(surveyData.endDate);
        }
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  const getSurveyDetails = (surveyId: number) => {
    return surveyService
      .getSurveyDetail(surveyId)
      .then((surveyDetails: ISurveyDetailDto[]) => {
        return surveyDetails;
      })
      .catch((error: any) => {
        console.error(error);
        throw error;
      });
  };

  const fillDataSurveyQuestions = (surveyDetails: ISurveyDetailDto[]) => {
    let questionsJson = JSON.parse(surveyDetails[0].questions);
    return new Promise<void>((resolve, reject) => {
      try {
        let questionsTemp: Questions[] = [];
        questionsJson.map((item: any, index: number) => {
          let questionOptionalTemp = Boolean(item.QuestionOptional);
          let optionConditionalTemp;
          let conditionTemp;

          if (questionOptionalTemp) {
            let indexQuestion = questionsJson.findIndex(
              (question: any) => question.QuestionID === item.OptionConditional
            );
            optionConditionalTemp = indexQuestion;
            conditionTemp = item.Condition;
          } else {
            optionConditionalTemp = NaN;
            conditionTemp = "";
          }

          questionsTemp.push({
            QuestionID: item.QuestionID,
            Input: item.Question,
            Type: item.Type,
            Mandatory: item.IsMandatory,
            PhotoMandatory: item.IsPhotoMandatory,
            Order: index,
            QuestionOptional: questionOptionalTemp,
            OptionConditional: optionConditionalTemp,
            Condition: conditionTemp,
            NumberOptions: item.Options ? [item.Options.length] : [],
            Options:
              item.Options && item.Options.map((item: any) => item.Option),
          });
        });
        setQuestions(questionsTemp);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  const fillDataSurveyFilters = (
    surveyDetails: ISurveyDetailDto[],
    roleList: SelectOption<SelectValue>[],
    countryList: SelectOption<SelectValue>[],
    subretailList: SelectOption<SelectValue>[]
  ) => {
    return new Promise<void>((resolve, reject) => {
      try {
        if (surveyDetails[0].roles.length > 0) {
          let rolesArray = surveyDetails[0].roles
            .split(",")
            .map((role) => parseInt(role.trim(), 10));
          let rolesTemp = rolesArray.filter((role: string | number) =>
            roleList?.some((r) => r.value === Number(role))
          );
          setRolesSelected([...rolesTemp]);
        }

        if (surveyDetails[0].countries.length > 0) {
          let countriesArray = surveyDetails[0].countries
            .split(",")
            .map((country) => parseInt(country.trim(), 10));
          let countriesTemp = countriesArray.filter(
            (country: string | number) =>
              countryList?.some((r) => r.value === Number(country))
          );
          setCountriesSelected([...countriesTemp]);
        }

        if (surveyDetails[0].subRetails.length > 0) {
          let subretailsArray = surveyDetails[0].subRetails
            .split(",")
            .map((subretail) => parseInt(subretail.trim(), 10));
          let subretailsTemp = subretailsArray.filter(
            (subretail: string | number) =>
              subretailList?.some((r) => r.value === Number(subretail))
          );
          setSubretailsSelected([...subretailsTemp]);
        }

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };

  const NumberOptions: SelectOption[] = [
    {
      value: 1,
      label: "1",
    },
    {
      value: 2,
      label: "2",
    },
    {
      value: 3,
      label: "3",
    },
    {
      value: 4,
      label: "4",
    },
    {
      value: 5,
      label: "5",
    },
    {
      value: 6,
      label: "6",
    },
    {
      value: 7,
      label: "7",
    },
    {
      value: 8,
      label: "8",
    },
    {
      value: 9,
      label: "9",
    },
    {
      value: 10,
      label: "10",
    },
  ];

  const QuestionTypes: SelectOption[] = [
    {
      value: 1,
      label: t("header.openQuestion"),
    },
    {
      value: 2,
      label: t("header.multipleAnswer"),
    },
    {
      value: 3,
      label: t("header.singleAnswer"),
    },
    {
      value: 4,
      label: t("header.ratingQuestion"),
    },
  ];

  const NumberQuestions: SelectOption[] = questions.reduce(
    (acc: SelectOption[], item, index) => {
      if (item.Type === 2 || item.Type === 3) {
        acc.push({
          value: index,
          label: String(index + 1),
        });
      }
      return acc;
    },
    []
  );

  const OptionsQuestions: SelectOption[] = optionsConditional.map(
    (item, index) => {
      return {
        value: item,
        label: item,
      };
    }
  );

  function getLabelQuestion(id: number): string | undefined {
    const QuestionTypes: { [key: number]: string } = {
      1: t("header.openQuestion"),
      2: t("header.multipleAnswer"),
      3: t("header.singleAnswer"),
      4: t("header.ratingQuestion"),
    };

    return QuestionTypes[id];
  }

  const validateConditional = () => {
    const hasEmptyNumberOptions = questions.some((item) => {
      if (Array.isArray(item.Options)) {
        return (
          (item.Type === 2 || item.Type === 3) &&
          item.NumberOptions.length === 0
        );
      }
      return false;
    });

    const hasEmptyOptions = questions.some((item) => {
      if (Array.isArray(item.Options)) {
        return item.Options.some((option) => option === "");
      }
      return false;
    });

    if (hasEmptyNumberOptions || hasEmptyOptions) {
      return false;
    } else {
      return true;
    }
  };

  const handleChangeSearchCities = (value: string) => {
    const filterArray = cities.filter((element) => {
      if (
        element.value
          .toString()
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        element.label
          ?.toString()
          .toLowerCase()
          .includes(String(value).toLowerCase())
      ) {
        return element;
      }
    });
    setCitiesFiltered(filterArray);
  };

  const handleChangeSearchPos = (value: string) => {
    const filterArray = pos.filter((element) => {
      if (
        element.value
          .toString()
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        element.label
          ?.toString()
          .toLowerCase()
          .includes(String(value).toLowerCase())
      ) {
        return element;
      }
    });
    setPosFiltered(filterArray);
  };

  const handleChangeCheckboxIndefinite = () => {
    setCheckboxIndefinite(!checkboxIndefinite);
    if (!checkboxIndefinite) {
      setStartDate("");
      setEndDate("");
    }
  };

  const handleChangeDates = (date: DateRange) => {
    date.startDate !== null && setStartDate(String(date.startDate));
    date.endDate !== null && setEndDate(String(date.endDate));
  };

  const handleChangeRoles = (value: SelectValue) => {
    const rolesCopy = [...rolesSelected];
    const isOptionSelected = rolesCopy.includes(value);
    if (isOptionSelected) {
      const index = rolesCopy.indexOf(value);
      rolesCopy.splice(index, 1);
    } else {
      rolesCopy.push(value);
    }
    setRolesSelected(rolesCopy);
  };

  const onClearRoles = () => {
    setRolesSelected([]);
  };

  const handleChangeCountries = (value: SelectValue) => {
    const countriesCopy = [...countriesSelected];
    const isOptionSelected = countriesCopy.includes(value);
    if (isOptionSelected) {
      const index = countriesCopy.indexOf(value);
      countriesCopy.splice(index, 1);
    } else {
      countriesCopy.push(value);
    }
    setCountriesSelected(countriesCopy);
  };

  const onClearCountries = () => {
    setCountriesSelected([]);
    setCitiesSelected([]);
    setCities([]);
    setCitiesFiltered([]);
    setDisabledCities(true);
  };

  const handleChangeCities = (value: SelectValue) => {
    const citiesCopy = [...citiesSelected];
    const isOptionSelected = citiesCopy.includes(value);
    if (isOptionSelected) {
      const index = citiesCopy.indexOf(value);
      citiesCopy.splice(index, 1);
    } else {
      citiesCopy.push(value);
    }
    setCitiesSelected(citiesCopy);
  };

  const onClearCities = () => {
    setCitiesSelected([]);
  };

  const handleChangeSubretails = (value: SelectValue) => {
    const subretailsCopy = [...subretailsSelected];
    const isOptionSelected = subretailsCopy.includes(value);
    if (isOptionSelected) {
      const index = subretailsCopy.indexOf(value);
      subretailsCopy.splice(index, 1);
    } else {
      subretailsCopy.push(value);
    }
    setSubretailsSelected(subretailsCopy);
  };

  const handleChangeQuestion = (value: string, indexQuestion: number) => {
    const updatedQuestions = [...questions];
    updatedQuestions[indexQuestion].Input = value;
    setQuestions(updatedQuestions);
  };

  const onClearSubretails = () => {
    setSubretailsSelected([]);
    setPosSelected([]);
    setPos([]);
    setPosFiltered([]);
    setDisabledPos(true);
  };

  const handleChangePos = (value: SelectValue) => {
    const posCopy = [...posSelected];
    const isOptionSelected = posCopy.includes(value);
    if (isOptionSelected) {
      const index = posCopy.indexOf(value);
      posCopy.splice(index, 1);
    } else {
      posCopy.push(value);
    }
    setPosSelected(posCopy);
  };

  const onClearPos = () => {
    setPosSelected([]);
  };

  const onAddQuestion = (
    type: number,
    questionOptional: boolean,
    OptionConditional: number,
    condition: string
  ) => {
    const questionsTemp = [...questions];
    questionsTemp.push({
      Input: "",
      Type: type,
      Mandatory: false,
      PhotoMandatory: false,
      Order: questionsTemp.length,
      QuestionOptional: questionOptional,
      OptionConditional: OptionConditional,
      Condition: condition,
      NumberOptions: [],
      Options: [],
    });
    setQuestions(questionsTemp);
  };

  const onDeleteQuestion = (index: number) => {
    const questionsTemp = [...questions];
    let indexes: number[] = [];

    questionsTemp.forEach((element, indexElement) => {
      if (element.OptionConditional === index) {
        indexes.push(indexElement);
      }
    });

    if (indexes.length > 0) {
      indexes.forEach((item) => {
        questionsTemp.splice(item, 1);
      });

      questionsTemp.splice(index, 1);
      setQuestions(questionsTemp);
    } else {
      questionsTemp.splice(index, 1);
      setQuestions(questionsTemp);
    }
  };

  const handleChangeCheckboxMandatory = (index: number) => {
    const questionsTemp = [...questions];
    questionsTemp[index].Mandatory = !questionsTemp[index].Mandatory;
    setQuestions(questionsTemp);
  };

  const handleChangeCheckboxPhotoMandatory = (index: number) => {
    const questionsTemp = [...questions];
    questionsTemp[index].PhotoMandatory = !questionsTemp[index].PhotoMandatory;
    setQuestions(questionsTemp);
  };

  const onClearNumberOptions = (index: number) => {
    const questionsTemp = [...questions];
    questionsTemp[index].NumberOptions = [];
    questionsTemp[index].Options = [];
    setQuestions(questionsTemp);
  };

  const handleChangeNumberOptions = (value: SelectValue, index: number) => {
    const questionsTemp = [...questions];

    if (questionsTemp[index].Options.length === 0 && Number(value) > 0) {
      questionsTemp[index].Options = new Array(Number(value)).fill("");
    } else if (questionsTemp[index].Options.length < Number(value)) {
      const diff = Number(value) - questionsTemp[index].Options.length;
      questionsTemp[index].Options = questionsTemp[index].Options.concat(
        new Array(diff).fill("")
      );
    } else if (questionsTemp[index].Options.length > Number(value)) {
      questionsTemp[index].Options = questionsTemp[index].Options.slice(
        0,
        Number(value)
      );
    }

    questionsTemp[index].NumberOptions = [value];
    setQuestions(questionsTemp);
  };

  const handleChangeOption = (
    value: string,
    index: number,
    indexOption: number
  ) => {
    const questionsTemp = [...questions];
    questionsTemp[index].Options[indexOption] = value;
    setQuestions(questionsTemp);
  };

  const confirmQuestionConditional = () => {
    onAddQuestion(
      Number(questionType),
      true,
      Number(indexQuestion),
      String(optionQuestion)
    );
    setShowModalConditional(false);
    setQuestionType([]);
    setIndexQuestion([]);
  };

  const onCancelQuestionConditional = () => {
    setShowModalConditional(false);
    setQuestionType([]);
    setIndexQuestion([]);
    setOptionsConditional([]);
    setOptionQuestion([]);
    setDisabledOptionQuestion(false);
  };

  const formatDateForAPI = (date: Date, isEndDate: boolean = false) => {
    const adjustedDate = new Date(date);

    if (isEndDate) {
      adjustedDate.setHours(23, 59, 59, 0);
    } else {
      adjustedDate.setHours(0, 0, 0, 0);
    }

    return (
      adjustedDate.getFullYear() +
      "-" +
      (adjustedDate.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      adjustedDate.getDate().toString().padStart(2, "0") +
      "T" +
      adjustedDate.getHours().toString().padStart(2, "0") +
      ":" +
      adjustedDate.getMinutes().toString().padStart(2, "0") +
      ":" +
      adjustedDate.getSeconds().toString().padStart(2, "0")
    );
  };

  const onSubmit = () => {
    setLoading(true);
    let currentDate = new Date();
    const startDateTemp = startDate ? new Date(startDate) : new Date();
    const endDateTemp = endDate ? new Date(endDate) : new Date();

    let surveyIn: ISurveyIn = {
      userID: NaN,
      surveyName: nameSurvey,
      startDate: formatDateForAPI(startDateTemp),
      endDate: formatDateForAPI(endDateTemp, true),
      isUndefined: checkboxIndefinite,
      jsonSurvey: JSON.stringify({
        Questions: questions.map((question, indexQuestion) => ({
          Input: question.Input,
          Type: question.Type,
          Mandatory: question.Mandatory,
          PhotoMandatory: question.PhotoMandatory,
          Order: indexQuestion + 1,
          QuestionOptional: question.QuestionOptional,
          OptionConditional: question.OptionConditional,
          Condition: question.Condition,
          Options: question.Options,
        })),
      }),
      countries: String(countriesSelected),
      subretails: String(subretailsSelected),
      roles: String(rolesSelected),
      cities: String(citiesSelected),
      pos: String(posSelected),
      date: currentDate.toISOString(),
    };
    try {
      surveyService.postSurvey(surveyIn).then((r) => {
        setLoading(false);

        if ((r.statusCode && r.statusCode >= 400) || r === 0) {
          setModalMessage({
            show: true,
            message: t("modal.generalError"),
            title: t("header.error"),
            onClose: () => setModalMessage((prevState) => ({ ...prevState, show: false }))
          });    
        } else {
          setModalMessage({
            show: true,
            message: t("modal.surveyCreatedMessage"),
            title: t("modal.surveyCreated"),
            onClose: () => {
              setModalMessage((prevState) => ({ ...prevState, show: false }));
              onClose();
            }
          }); 
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
      setModalMessage({
        show: true,
        message: t("modal.generalError"),
        title: t("header.error"),
        onClose: () => setModalMessage((prevState) => ({ ...prevState, show: false }))
      });    
    }
  };

  const onUpdate = () => {
    setLoading(true);
    const startDateTemp = startDate ? new Date(startDate) : new Date();
    const endDateTemp = endDate ? new Date(endDate) : new Date();

    let surveyUpdateIn: ISurveyUpdateIn = {
      surveyID: surveyId,
      surveyName: nameSurvey,
      startDate: formatDateForAPI(startDateTemp),
      endDate: formatDateForAPI(endDateTemp, true),
      isUndefined: checkboxIndefinite,
      jsonSurvey: JSON.stringify({
        Questions: questions.map((question, indexQuestion) => ({
          QuestionID: question.QuestionID ? question.QuestionID : null,
          Input: question.Input,
          Type: question.Type,
          Mandatory: question.Mandatory,
          PhotoMandatory: question.PhotoMandatory,
          Order: indexQuestion + 1,
          QuestionOptional: question.QuestionOptional,
          OptionConditional: question.OptionConditional,
          Condition: question.Condition,
          Options: question.Options,
        })),
      }),
      countries: String(countriesSelected),
      subretails: String(subretailsSelected),
      roles: String(rolesSelected),
      cities: String(citiesSelected),
      pos: String(posSelected),
    };
    try {
      surveyService.updateSurvey(surveyUpdateIn).then((r) => {
        setLoading(false);
        if ((r.statusCode && r.statusCode >= 400) || r === 0) {
          setModalMessage({
            show: true,
            message: t("modal.generalError"),
            title: t("header.error"),
            onClose: () => setModalMessage((prevState) => ({ ...prevState, show: false }))
          });       
        } else {
          setModalMessage({
            show: true,
            message: t("modal.surveyUpdatedMessage"),
            title: t("modal.surveyUpdated"),
            onClose: () => {
              setModalMessage((prevState) => ({ ...prevState, show: false }));
              onClose();
            }
          });    
        }
      });
    } catch (error) {
      console.error(error);
      setLoading(false);
      setModalMessage({
            show: true,
            message: t("modal.generalError"),
            title: t("header.error"),
            onClose: () => setModalMessage((prevState) => ({ ...prevState, show: false }))
          });    
    }
  };

  return (
    <>
      {loading && <LoaderModal />}

      <div style={{ position: "relative" }}>
        <Modal
          className="surveyEditorModal"
          align="center"
          id="surveyEditorModal"
          onClose={onClose}
          show={true}
          footer={(() => {
            switch (numberTab) {
              case 0:
                return (
                  <ButtonGroup className="surveyEditorModalButtonGroup">
                    <Button
                      disabled={tab0Disable}
                      onClick={() => setNumberTab(1)}
                    >
                      {t("header.next")}
                    </Button>
                    <Button onClick={() => onClose()} appearance="secondary">
                      {t("header.cancel")}
                    </Button>
                  </ButtonGroup>
                );
                break;

              case 1:
                return (
                  <ButtonGroup className="surveyEditorModalButtonGroup">
                    <Button onClick={() => setNumberTab(0)}>
                      {t("header.back")}
                    </Button>
                    <Button disabled={false} onClick={() => setNumberTab(2)}>
                      {t("header.next")}
                    </Button>
                    <Button onClick={() => onClose()} appearance="secondary">
                      {t("header.cancel")}
                    </Button>
                  </ButtonGroup>
                );
                break;
              case 2:
                return (
                  <ButtonGroup className="surveyEditorModalButtonGroup">
                    <Button onClick={() => setNumberTab(1)}>
                      {t("header.back")}
                    </Button>
                    <Button
                      disabled={tab2Disable}
                      onClick={() => setNumberTab(3)}
                    >
                      {t("header.next")}
                    </Button>
                    <Button onClick={() => onClose()} appearance="secondary">
                      {t("header.cancel")}
                    </Button>
                  </ButtonGroup>
                );
              case 3:
                return (
                  <ButtonGroup className="surveyEditorModalButtonGroup">
                    <Button onClick={() => setNumberTab(2)}>
                      {t("header.back")}
                    </Button>
                    <Button onClick={isUpdating ? onUpdate : onSubmit}>
                      {t("header.submit")}
                    </Button>
                    <Button onClick={() => onClose()} appearance="secondary">
                      {t("header.cancel")}
                    </Button>
                  </ButtonGroup>
                );
                break;
              default:
                <p>{t("header.error")}</p>;
            }
          })()}
          title={
            isUpdating ? t("header.updateSurvey") : t("header.createSurvey")
          }
        >
          <>
            {(() => {
              switch (numberTab) {
                case 0:
                  return (
                    <div className="surveyEditorModalTab0">
                      <TextBox
                        className="surveyEditorModalTextbox"
                        label={t("header.surveyName")}
                        id={"surveyEditorModal"}
                        value={nameSurvey}
                        onChange={(value) => setSurveyName(value)}
                      />

                      <Checkbox
                        className="surveyEditorModalCheckbox"
                        id="surveyEditorModalCheckbox"
                        value={checkboxIndefinite}
                        checked={checkboxIndefinite}
                        onChange={handleChangeCheckboxIndefinite}
                        label={t("header.indefiniteSurveyQuestion")}
                      />

                      {!checkboxIndefinite && (
                        <DatePicker
                          className="surveyEditorModalDatepicker"
                          blockPastDates
                          clearIcon={false}
                          endDate={endDate}
                          onChange={(date) =>
                            handleChangeDates(date as DateRange)
                          }
                          orientation="horizontal"
                          range
                          startDatePlaceholder="mm/dd/yyyy"
                          endDatePlaceholder="mm/dd/yyyy"
                          format="LL"
                          startDate={startDate}
                          startDateLabel={t("header.stardDate")}
                          endDateLabel={t("header.endDate")}
                          maxDate={
                            !isUpdating
                              ? moment(startDate).add(12, "months")
                              : undefined
                          }
                          minimumNights={1}
                          error={errorDatePicker}
                        />
                      )}
                    </div>
                  );
                  break;

                case 1:
                  return (
                    <>
                      <b>{t("header.filters")}</b>

                      <Select
                        className="surveyEditorModalSelects"
                        label={t("header.roles")}
                        onChange={(e) => handleChangeRoles(e.value)}
                        onClear={onClearRoles}
                        options={roles}
                        value={rolesSelected}
                        placement="bottom-start"
                        multiple
                        disabled={disabledRoles}
                      />

                      <Select
                        className="surveyEditorModalSelects"
                        label={t("header.countries")}
                        onChange={(e) => handleChangeCountries(e.value)}
                        onClear={onClearCountries}
                        options={countries}
                        value={countriesSelected}
                        placement="bottom-start"
                        multiple
                        disabled={disabledCountries}
                      />

                      <Select
                        className="surveyEditorModalSelects"
                        label={t("header.cities")}
                        onChange={(e) => handleChangeCities(e.value)}
                        onClear={onClearCities}
                        options={citiesFiltered}
                        value={citiesSelected}
                        placement="bottom-start"
                        multiple
                        disabled={disabledCities}
                        showSearch
                        onSearch={handleChangeSearchCities}
                      />

                      <Select
                        className="surveyEditorModalSelects"
                        label={t("header.subretails")}
                        onChange={(e) => handleChangeSubretails(e.value)}
                        onClear={onClearSubretails}
                        options={subretails}
                        value={subretailsSelected}
                        placement="bottom-start"
                        multiple
                        disabled={disabledSubretails}
                      />

                      <Select
                        className="surveyEditorModalSelects"
                        label={t("header.posPlural")}
                        onChange={(e) => handleChangePos(e.value)}
                        onClear={onClearPos}
                        options={posFiltered}
                        value={posSelected}
                        placement="bottom-start"
                        multiple
                        disabled={disabledPos}
                        showSearch
                        onSearch={handleChangeSearchPos}
                      />
                    </>
                  );
                  break;
                case 2:
                  return (
                    <>
                      <Button
                        className="surveyEditorModalButtonQuestions"
                        onClick={() => onAddQuestion(1, false, NaN, "")}
                        leadingIcon={<IconPlus />}
                      >
                        {t("header.openQuestion")}
                      </Button>
                      <Button
                        className="surveyEditorModalButtonQuestions"
                        onClick={() => onAddQuestion(2, false, NaN, "")}
                        leadingIcon={<IconPlus />}
                      >
                        {t("header.multipleAnswer")}
                      </Button>
                      <Button
                        className="surveyEditorModalButtonQuestions"
                        onClick={() => onAddQuestion(3, false, NaN, "")}
                        leadingIcon={<IconPlus />}
                      >
                        {t("header.singleAnswer")}
                      </Button>
                      <Button
                        className="surveyEditorModalButtonQuestions"
                        onClick={() => onAddQuestion(4, false, NaN, "")}
                        leadingIcon={<IconPlus />}
                      >
                        {t("header.ratingQuestion")}
                      </Button>
                      {questions.some(
                        (item) => item.Type === 2 || item.Type === 3
                      ) &&
                        validateConditional() && (
                          <Button
                            className="surveyEditorModalButtonQuestions"
                            onClick={() => setShowModalConditional(true)}
                            leadingIcon={<IconPlus />}
                          >
                            {t("header.conditionalQuestion")}
                          </Button>
                        )}

                      <div className="surveyEditorModalCards">
                        {questions.map((question, indexQuestion) => {
                          switch (question.Type) {
                            case 1:
                            case 4:
                              return (
                                <Card
                                  appearance="dropShadow"
                                  className="surveyEditorModalCard"
                                  content={
                                    <>
                                      <div className="surveyEditorModalCardTop">
                                        <b>{indexQuestion + 1}</b>
                                        <p>
                                          {question.Type === 1
                                            ? t("header.openQuestion")
                                            : t("header.ratingQuestion")}
                                        </p>
                                        <Button
                                          className="surveyEditorModalCardButtonDelete"
                                          appearance="secondary"
                                          colorScheme="negative"
                                          onClick={() =>
                                            onDeleteQuestion(indexQuestion)
                                          }
                                          leadingIcon={<IconX />}
                                        />
                                      </div>
                                      {question.QuestionOptional && (
                                        <span style={{ fontSize: "small" }}>
                                          {t(
                                            "header.messageQuestionConditional"
                                          ) +
                                            " " +
                                            (Number(
                                              question.OptionConditional
                                            ) +
                                              1)}{" "}
                                        </span>
                                      )}

                                      <TextBox
                                        className="surveyEditorModalTextbox"
                                        label={t("header.question")}
                                        id={"surveyEditorModal"}
                                        value={question.Input}
                                        onChange={(value) =>
                                          handleChangeQuestion(
                                            value,
                                            indexQuestion
                                          )
                                        }
                                      />

                                      <div className="surveyEditorModalCheckboxes">
                                        <Checkbox
                                          className="surveyEditorModalCheckbox"
                                          id={`checkbox-mandatory-${indexQuestion}`}
                                          value={question.Mandatory}
                                          checked={question.Mandatory}
                                          onChange={() =>
                                            handleChangeCheckboxMandatory(
                                              indexQuestion
                                            )
                                          }
                                          label={
                                            <span style={{ fontSize: "small" }}>
                                              {t("header.mandatory")}
                                            </span>
                                          }
                                        />
                                        <Checkbox
                                          className="surveyEditorModalCheckbox"
                                          id={`checkbox-photo-mandatory-${indexQuestion}`}
                                          value={question.PhotoMandatory}
                                          checked={question.PhotoMandatory}
                                          onChange={() =>
                                            handleChangeCheckboxPhotoMandatory(
                                              indexQuestion
                                            )
                                          }
                                          label={
                                            <span style={{ fontSize: "small" }}>
                                              {t("header.photoMandatory")}
                                            </span>
                                          }
                                        />
                                      </div>
                                    </>
                                  }
                                />
                              );
                            case 2:
                            case 3:
                              return (
                                <Card
                                  appearance="dropShadow"
                                  className="surveyEditorModalCard"
                                  content={
                                    <>
                                      <div className="surveyEditorModalCardTop">
                                        <b>{indexQuestion + 1}</b>
                                        <p>
                                          {question.Type === 2
                                            ? t("header.multipleAnswer")
                                            : t("header.singleAnswer")}
                                        </p>
                                        <Button
                                          className="surveyEditorModalCardButtonDelete"
                                          appearance="secondary"
                                          colorScheme="negative"
                                          onClick={() =>
                                            onDeleteQuestion(indexQuestion)
                                          }
                                          leadingIcon={<IconX />}
                                        />
                                      </div>
                                      {question.QuestionOptional && (
                                        <span style={{ fontSize: "small" }}>
                                          {t(
                                            "header.messageQuestionConditional"
                                          ) +
                                            " " +
                                            (Number(
                                              question.OptionConditional
                                            ) +
                                              1)}{" "}
                                        </span>
                                      )}

                                      <TextBox
                                        className="surveyEditorModalTextbox"
                                        label={t("header.question")}
                                        id={"surveyEditorModal"}
                                        value={question.Input}
                                        onChange={(value) =>
                                          handleChangeQuestion(
                                            value,
                                            indexQuestion
                                          )
                                        }
                                      />

                                      <div className="surveyEditorModalCheckboxes">
                                        <Checkbox
                                          className="surveyEditorModalCheckbox"
                                          id={`checkbox-mandatory-${indexQuestion}`}
                                          value={question.Mandatory}
                                          checked={question.Mandatory}
                                          onChange={() =>
                                            handleChangeCheckboxMandatory(
                                              indexQuestion
                                            )
                                          }
                                          label={
                                            <span style={{ fontSize: "small" }}>
                                              {t("header.mandatory")}
                                            </span>
                                          }
                                        />
                                        <Checkbox
                                          className="surveyEditorModalCheckbox"
                                          id={`checkbox-photo-mandatory-${indexQuestion}`}
                                          value={question.PhotoMandatory}
                                          checked={question.PhotoMandatory}
                                          onChange={() =>
                                            handleChangeCheckboxPhotoMandatory(
                                              indexQuestion
                                            )
                                          }
                                          label={
                                            <span style={{ fontSize: "small" }}>
                                              {t("header.photoMandatory")}
                                            </span>
                                          }
                                        />
                                      </div>

                                      <Select
                                        className="surveyEditorModalSelects"
                                        label={t("header.numberOptions")}
                                        onChange={(e) =>
                                          handleChangeNumberOptions(
                                            e.value,
                                            indexQuestion
                                          )
                                        }
                                        onClear={() =>
                                          onClearNumberOptions(indexQuestion)
                                        }
                                        options={NumberOptions}
                                        value={question.NumberOptions}
                                        placement="bottom-start"
                                      />

                                      {question.Options.map(
                                        (option, indexOption) => {
                                          return (
                                            <TextBox
                                              className="surveyEditorModalTextboxOption"
                                              label={`${t("header.option")} ${
                                                indexOption + 1
                                              }`}
                                              id={"surveyEditorModalOption"}
                                              value={option}
                                              onChange={(value) =>
                                                handleChangeOption(
                                                  value,
                                                  indexQuestion,
                                                  indexOption
                                                )
                                              }
                                            />
                                          );
                                        }
                                      )}
                                    </>
                                  }
                                />
                              );
                          }
                        })}
                      </div>
                    </>
                  );
                  break;

                case 3:
                  return (
                    <div className="surveyEditorModalResume">
                      {questions.map((item, index) => {
                        return (
                          <ListItem
                            key={"survey" + index}
                            leadingArea={
                              <div>
                                <b>{item.Input}</b>
                                <br></br>
                                <span style={{ fontSize: "small" }}>
                                  {t("header.questionType") +
                                    " " +
                                    getLabelQuestion(item.Type)}{" "}
                                </span>
                                <div className="surveyEditorModalResumeOptions">
                                  {item.Options?.map(
                                    (option: string, indexOption: number) => {
                                      if (item.Type === 2) {
                                        return (
                                          <Checkbox
                                            disabled
                                            id="checkbox"
                                            label={option}
                                          />
                                        );
                                      } else if (item.Type === 3) {
                                        return (
                                          <RadioButton
                                            disabled
                                            id="radio-id"
                                            label={option}
                                          />
                                        );
                                      }
                                    }
                                  )}
                                </div>
                              </div>
                            }
                          />
                        );
                      })}
                    </div>
                  );
                  break;
                default:
                  <p>{t("header.error")}</p>;
              }
            })()}
          </>
        </Modal>

        <div style={{ position: "relative" }}>
          <Modal
            className="surveyEditorModalConditional"
            align="center"
            id="surveyEditorModalConditional"
            show={showModalConditional}
            onClose={onCancelQuestionConditional}
            closeButton
            footer={
              <ButtonGroup className="validationTestButtonGroup">
                <Button
                  disabled={disabledAddConditional}
                  onClick={() => confirmQuestionConditional()}
                >
                  {t("header.confirm")}
                </Button>
                <Button
                  onClick={onCancelQuestionConditional}
                  appearance="secondary"
                >
                  {t("header.cancel")}
                </Button>
              </ButtonGroup>
            }
            title={t("header.conditionalQuestion")}
          >
            <b>{t("header.messageAddQuestionConditional")}</b>

            <Select
              className="surveyEditorModalSelects"
              label={t("header.questionType")}
              onChange={(e) => setQuestionType([e.value])}
              onClear={() => setQuestionType([])}
              options={QuestionTypes}
              value={questionType}
              placement="bottom-start"
            />
            <Select
              className="surveyEditorModalSelects"
              label={t("header.indexQuestion")}
              onChange={(e) => setIndexQuestion([e.value])}
              onClear={() => setIndexQuestion([])}
              options={NumberQuestions}
              value={indexQuestion}
              placement="bottom-start"
            />
            <Select
              className="surveyEditorModalSelects"
              label={t("header.optionQuestion")}
              onChange={(e) => setOptionQuestion([e.value])}
              onClear={() => setOptionQuestion([])}
              options={OptionsQuestions}
              value={optionQuestion}
              placement="bottom-start"
              disabled={disabledOptionQuestion}
            />
          </Modal>
        </div>

        <SimpleMessageModalWithOpenClose
          showModal={modalMessage.show}
          setOpenCloseModal={modalMessage.onClose}
          modalTitle={modalMessage.title}
          modalMessage={modalMessage.message}
        />
      </div>
    </>
  );
};

export default SurveyEditorModal;
